/**
 * @file life-cycle.icon.tsx
 * @description Компонент для отображения иконки жизненного цикла.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 */

import { IIconProps } from '@src/types';

export const LifeCycleIcon = (props: IIconProps) => {
    return (
        <div {...props}>
            <svg
                width="1.6937vmin"
                height="1.6937vmin"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.40696 3.78947C5.40696 4.22548 5.02004 4.57894 4.54275 4.57894C4.06547 4.57894 3.67855 4.22548 3.67855 3.78947C3.67855 3.35346 4.06547 3 4.54275 3C5.02004 3 5.40696 3.35346 5.40696 3.78947ZM4.5427 5.67673L7.08589 8L6.27111 8.74432L5.11872 7.69159L5.11883 10.1053C5.11883 10.9773 5.89267 11.6842 6.84723 11.6842H9.15179V12.7368H6.84723C5.25629 12.7368 3.96657 11.5586 3.96657 10.1053L3.96644 7.69159L2.81429 8.74432L1.99951 8L4.5427 5.67673ZM9.15179 3.26317C10.7427 3.26317 12.0325 4.44135 12.0325 5.89475L12.0323 8.30738L13.1847 7.25568L13.9995 8L11.4563 10.3233L8.91314 8L9.72792 7.25568C10.1118 7.60642 10.4958 7.95698 10.8801 8.30738L10.8802 5.89475C10.8802 5.0227 10.1064 4.3158 9.15179 4.3158H6.84723V3.26317H9.15179ZM11.4564 13C11.9337 13 12.3206 12.6465 12.3206 12.2105C12.3206 11.7745 11.9337 11.4211 11.4564 11.4211C10.9791 11.4211 10.5922 11.7745 10.5922 12.2105C10.5922 12.6465 10.9791 13 11.4564 13Z"
                    fill="black"
                />
            </svg>
        </div>
    );
};
